import { createApp } from 'vue';
import { createPinia } from 'pinia';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import axios from 'axios';
import App from './App.vue';
import router from './router';
import './assets/css/main.css';
import { useAuthStore } from './stores/auth';
import { API_BASE_URL } from './config/api';
// Set default axios base URL from centralized config
axios.defaults.baseURL = API_BASE_URL;
const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(router);
// Initialize auth store after pinia is set up
const authStore = useAuthStore();
authStore.initializeAuth();
// Set up axios interceptor for authentication
axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
app.use(Toast, {
    position: 'top-right',
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: 'button',
    icon: true,
    rtl: false
});
app.mount('#app');
// Prevent FOUC by showing content after Vue is mounted
document.documentElement.classList.add('wf-active');
